import { qdfoodApi } from './constant';
import { IUser } from '@type/user';

export interface IUpdatPassword {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const USER_API = {
  urlGetUserInfo: `/auth/info`,
  urlUpdateUser: `/user`,
  urlPassword: `/user/password`,
};

export default class userApi {
  static getUserInfo() {
    return qdfoodApi().get<IUser>(USER_API.urlGetUserInfo);
  }
  static updateUserInfo(value: IUser) {
    return qdfoodApi().put<IUser>(USER_API.urlUpdateUser, value);
  }
  static updatePassword(value: IUpdatPassword) {
    return qdfoodApi().put<IUser>(USER_API.urlPassword, value);
  }
}
